/* global jQuery, document */
// import map from 'lodash/fp/map';
import Cookies from 'js-cookie';

(($, Drupal) => {
  /* global window, Drupal */
  /* eslint-disable no-param-reassign */
  Drupal.behaviors.jeromeAlerts = {
    attach: () => {
      window.once('jerome.alerts', document.body).forEach(() => {
        // Alerts are displayed a max of once per day for each uuid, or if
        // viewing the alert content type.
        const alert = document.querySelector('#block-views-block-alert-block-1 .alert');
        if (alert) {
          const changed = alert.querySelector('[data-changed]').getAttribute('data-changed');
          const cookie = Cookies.get('jerome-site-alert');
          if (!cookie ||
              parseInt(changed, 10) * 1000 > parseInt(cookie, 10)) {
            alert.classList.add('show');
            alert.classList.add('fade');
            alert.classList.add('in');
            document.getElementById('block-views-block-alert-block-1').classList.add('show');
          }
          $(alert).on('closed.bs.alert', () => {
            document.getElementById('block-views-block-alert-block-1').classList.remove('show');
            Cookies.set('jerome-site-alert', Date.now(), {
              expires: new Date(new Date().getTime() + (5 * 60 * 1000)),
            });
          });
        }
      });
    },
  };
})(jQuery, Drupal);
